module.exports = __webpack_public_path__ + "static/home4-ce44facf6e6877aa45abab438431bbae.jpg";